import React from 'react';
import styled, { Palette } from 'styled-components';

export interface TinkLogoProps {
  color?: Palette;
  height?: string;
  tColor?: Palette;
  width?: string;
  noText?: boolean;
  offset?: string;
  hoverable?: boolean;
}

interface ColorProps {
  color?: Palette;
}

interface SymbolColorProps {
  tColor?: Palette;
}

export const StyledTinkLogo = styled.svg.attrs({ role: 'presentation' })<TinkLogoProps>`
  height: ${(props) => (props.height ? props.height : '2.375rem')};
  width: ${(props) => (props.width ? props.width : '3rem')};

  /* Because of the logo composition, it needs to be offset to look centered in certain contexts */
  ${(props) =>
    props.offset &&
    `
    position: relative;
    top: ${props.offset};
    `}

  ${(props) =>
    props.hoverable &&
    `
    &:hover {
      opacity: 0.8;
    }
  `}
`;

export const TinkLogoStyledText = styled.path<ColorProps>`
  fill: ${(props) =>
    props.color ? props.theme.palette[props.color].main : props.theme.palette.black.main};
`;

const T = styled.g<SymbolColorProps>`
  fill: ${(props) =>
    props.tColor ? props.theme.palette[props.tColor].main : props.theme.palette.secondary.main};
`;

export const TinkLogo: React.FunctionComponent<TinkLogoProps> = (props) => {
  if (props.noText) {
    return (
      <StyledTinkLogo {...props} viewBox="0 0 20 35">
        <T tColor={props.tColor}>
          <path
            fillRule="evenodd"
            d="M0 7.778c3.982 0 7.222-3.49 7.222-7.778H13c0 7.736-5.817 14-13 14m20 21c-7.183 0-13-6.045-13-13.51S12.817 8 20 8v6.005c-3.982 0-7.222 3.367-7.222 7.505s3.24 7.506 7.222 7.506"
          />
        </T>
      </StyledTinkLogo>
    );
  }

  return (
    <StyledTinkLogo {...props} viewBox="0 0 64 30">
      <TinkLogoStyledText
        color={props.color}
        d="M8.827 26.764c-2.092 0-2.807-1.033-2.807-2.53v-6.68h4.592v-3.063H6.02V9.138H2.466v5.353H0v3.098h2.245v6.73c0 3.409 2.194 5.664 6.02 5.664 1.089 0 2.041-.19 2.568-.413l-.119-3.15c-.595.258-1.207.344-1.887.344zM13.027 14.491h3.759v15.354h-3.759zM13.027 9.138h3.759v3.374h-3.759zM27.687 14.336c-2.279 0-3.86.964-4.745 2.375l-.119-2.22h-3.605v15.337h3.741v-8.71c0-2.1 1.327-3.511 3.368-3.511 1.921 0 2.908 1.29 2.908 3.442v8.779h3.792v-9.64c0-3.545-1.973-5.852-5.34-5.852zM43.656 20.843l5.647-6.352h-4.507l-5.714 6.627V9.138h-3.759v20.69h3.759v-3.873l2.159-2.41 4.354 6.283h4.286z"
      />
      <T tColor={props.tColor}>
        <path d="M51.07 4.878c2.651 0 4.8-2.115 4.8-4.725h3.831c0 4.69-3.865 8.494-8.632 8.494v-3.77z" />
        <path d="M63.93 8.664c-2.651 0-4.8 2.114-4.8 4.724 0 2.609 2.149 4.724 4.8 4.724v3.769c-4.766 0-8.631-3.803-8.631-8.493s3.865-8.493 8.632-8.493v3.769z" />
      </T>
    </StyledTinkLogo>
  );
};
